import { HookType } from '@/utils';
import { Tooltip } from '@reach/tooltip';
import Editor from '@uiw/react-textarea-code-editor';
import cn from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { IconButton } from '@/components/atom';
import styles from './hookEntry.module.less';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default class HookEntry extends React.PureComponent {
  static get propTypes() {
    return {
      id: PropTypes.string,
      hook: HookType,
      toggleHook: PropTypes.func,
      deleteHook: PropTypes.func,
      alertSuccess: PropTypes.func,
      openHook: PropTypes.func,
      showConfirmModal: PropTypes.func,
      editable: PropTypes.bool
    };
  }
  static defaultProps() {
    return {
      editable: false
    };
  }
  constructor(props) {
    super(props);
    this.state = {
      name: props.hook.name,
      description: props.hook.description,
      code: props.hook.code
    };
  }
  render() {
    const {
      opened
    } = this.props.hook;
    return /*#__PURE__*/_jsxs("div", {
      className: cn(styles.container, {
        [styles['container--opened']]: opened
      }),
      children: [this._renderEntry(), this._renderForm()]
    });
  }
  _renderEntry() {
    const {
      editable
    } = this.props;
    const {
      enabled
    } = this.props.hook;
    const {
      name,
      description
    } = this.state;
    return /*#__PURE__*/_jsxs("div", {
      onClick: e => this.onOpen(e),
      className: styles.infoWrapper,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.hookInfo,
        children: [/*#__PURE__*/_jsx("h4", {
          children: name
        }), /*#__PURE__*/_jsx("p", {
          children: description
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.actions,
        children: editable && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Tooltip, {
            label: enabled ? 'Disable hook' : 'Enable hook',
            children: /*#__PURE__*/_jsx("span", {
              children: /*#__PURE__*/_jsx(IconButton, {
                name: "enable",
                color: enabled ? 'success' : 'danger',
                onClick: e => this.onEnable(e)
              })
            })
          }), /*#__PURE__*/_jsx(Tooltip, {
            label: "Delete hook",
            children: /*#__PURE__*/_jsx("span", {
              children: /*#__PURE__*/_jsx(IconButton, {
                name: "trash",
                onClick: e => this.onDelete(e)
              })
            })
          })]
        })
      })]
    });
  }
  _renderForm() {
    const {
      editable,
      hook
    } = this.props;
    const {
      name,
      description,
      code
    } = this.state;
    const {
      id,
      opened
    } = hook;
    return /*#__PURE__*/_jsxs("div", {
      className: cn(styles.formWrapper, {
        [styles['formWrapper--opened']]: opened
      }),
      children: [/*#__PURE__*/_jsx("input", {
        onChange: e => this.onChange(e),
        disabled: !editable,
        name: `name__${id}`,
        value: name,
        className: styles.input,
        type: "text",
        placeholder: "Name"
      }), /*#__PURE__*/_jsx("input", {
        onChange: e => this.onChange(e),
        disabled: !editable,
        name: `description__${id}`,
        value: description,
        className: styles.input,
        type: "text",
        placeholder: "Description"
      }), /*#__PURE__*/_jsx(Editor, {
        name: `code__${id}`,
        disabled: !editable,
        language: "js",
        className: cn(styles.input, styles.codeInput),
        placeholder: "// code",
        value: code,
        onChange: event => this.setState({
          code: event.target.value
        }),
        padding: 10,
        style: {
          overflow: 'auto'
        }
      })]
    });
  }
  onChange({
    target: {
      value,
      name
    }
  }) {
    this.setState({
      [name.split('__')[0]]: value
    });
  }
  onDelete(e) {
    e.preventDefault();
    e.stopPropagation();
    const {
      deleteHook,
      hook,
      alertSuccess,
      showConfirmModal
    } = this.props;
    showConfirmModal({
      body: /*#__PURE__*/_jsxs("p", {
        children: ["Are you sure you ", /*#__PURE__*/_jsx("strong", {
          children: "want to delete"
        }), " '", hook.name, "' hook?"]
      }),
      accept: () => {
        deleteHook(hook.id);
        alertSuccess(`'${hook.name}' hook was deleted.`);
      }
    });
  }
  onEnable(e) {
    e.preventDefault();
    e.stopPropagation();
    const {
      toggleHook,
      hook,
      alertSuccess
    } = this.props;
    toggleHook(hook.id);
    alertSuccess(`'${hook.name}' hook was ${hook.enabled ? 'disabled' : 'enabled'}.`);
  }
  onOpen(e) {
    e.preventDefault();
    const {
      openHook,
      hook
    } = this.props;
    openHook(hook.id);
  }
}